import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "./fromverify.scss";
import axios from "axios";
import ShowCertificateModel from "./ShowCertificateModel";
import { toast } from "react-toastify";

const FormVerify = () => {
  const [certificateId, setCertificateId] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [showCertificateModel, setShowCertificateModel] = useState(false);

  const submitInfo = () => {
    axios
      .get(`https://mis.gemsholdings.com/api/v1/cert.php?uid=${certificateId}`)
      // .get(`https://mocki.io/v1/f1d3ce9b-399f-4f74-b070-836ae6ab32fb`)
      .then((response) => {
        setCertificateData(response.data);
        setCertificateId("");
        setShowCertificateModel(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        toast.error(error?.response?.data?.error, {
          theme: "dark",
        });
      });
  };

  return (
    <>
      <Form className="from-verfy">
        <Row>
          <p className="m-0">Certificate code</p>
          <Col className="class-veri-col-fom">
            <Form.Group controlId="formGroupEmail" className="from-input">
              <Form.Control
                type="text"
                placeholder="Enter Certificate code"
                value={certificateId}
                onChange={(e) => setCertificateId(e.target.value)}
              />
            </Form.Group>
            <Button onClick={submitInfo}>Verify</Button>
          </Col>
        </Row>
      </Form>

      <p className="mt-5 clas-conat">
        Have problems or questions about your GEMS certification? Submit the{" "}
        <a
          href="https://gems.edu.np/contact-us"
          target="_blank"
          rel="noopener noreferrer"
        >
          contact form.
        </a>
      </p>

      {certificateData && (
        <ShowCertificateModel
          onHide={() => {
            setShowCertificateModel(false);
          }}
          show={showCertificateModel}
          certificateData={certificateData}
        />
      )}
    </>
  );
};

export default FormVerify;
